/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_Link_Item_Not_FoundInputs */

const vi_error_kiotviet_link_item_not_found = /** @type {(inputs: Error_Kiotviet_Link_Item_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy dòng hàng này trong đơn. Tải lại trang rồi thử lại.`)
};

/**

* @param {Error_Kiotviet_Link_Item_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_link_item_not_found = /** @type {((inputs?: Error_Kiotviet_Link_Item_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Link_Item_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_link_item_not_found(inputs)
});